import {isArrayEmpty, isNullOrUndefined} from "../../../services/Validator";
import CoursesLevelAsVoid from "../../voids/courses/CoursesLevelAsVoid";
import CoursesLevelAItem from "../../items/courses/CoursesLevelAItem";

export default function CoursesLevelAsList({  levelAs,
                                              pickLevelA,
                                              clearLevelAs,
                                              selectedLevelAs,
                                              // ---- Flash
                                              isFlashLoading,
                                              fetchFlashQuestions,
                                              // ---- Exerciser
                                              isExerciserLoading,
                                              fetchExerciserProblem }) {
    // Used in CoursesSubthemesContent to
    // display list of flash levels to pick

    // BUILD
    if (isNullOrUndefined(levelAs))
        return null
    if (isArrayEmpty(levelAs))
        return <CoursesLevelAsVoid />
    return (
        <div className={"overflow-auto bg-backgroundLight3 w-full grow flex flex-col justify-start items-center py-[10px] space-y-[6px]"}>
            {levelAs?.map((levelA, index) => (
                <CoursesLevelAItem key={index}
                                   index={index}
                                   total={levelAs.length}
                                   levelA={levelA}
                                   fetchFlashQuestions={fetchFlashQuestions}
                                   isFlashLoading={isFlashLoading}
                                   pickLevelA={pickLevelA}
                                   clearLevelAs={clearLevelAs}
                                   selectedLevelAs={selectedLevelAs}
                                   isExerciserLoading={isExerciserLoading}
                                   fetchExerciserProblem={fetchExerciserProblem} />
            ))}
        </div>
    );
}